// extracted by mini-css-extract-plugin
module.exports = {"gettingStartedButton":"GetStartedButton_gettingStartedButton__g5B66","jiggling":"GetStartedButton_jiggling__gpJxk","jiggle":"GetStartedButton_jiggle__QDj_2"};